module.exports = __webpack_public_path__ + "static/img/privacy-5.314dcf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/privacy-5.png
// module id = xKet
// module chunks = 1